const applierTypeEnum = {
  SITEOWNER: 'Owner',
  APPLICANT: 'Applicant',
  CONTRACTOR: 'Contractor',
  INSTALLER: 'Installer',
  ENGINEER: 'Engineer',
};

export {
  applierTypeEnum,
};
